import {
  Button,
  CloseButton,
  Dialog,
  DialogTrigger,
  Modal,
  ModalOverlay,
} from "@light-technology/components";
import { type ReactNode, useState } from "react";

type ConfirmRemoveModalProps = {
  title: string;
  description: string;
  onConfirm: () => void;
  children: ReactNode;
  "data-ph-capture-attribute-action"?: string;
};

export const ConfirmRemoveModal = (props: ConfirmRemoveModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = () => {
    props.onConfirm();
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
      {props.children}
      <ModalOverlay isDismissable>
        <Modal>
          <Dialog>
            <div className="relative w-full max-w-100 rounded-2xl bg-primary p-3xl">
              <CloseButton
                className="absolute top-0 right-0"
                size="lg"
                onClick={handleCancel}
              />
              <div className="pr-2xl pb-2xl">
                <div className="pb-2 text-base font-semibold">
                  {props.title}
                </div>
                <div className="text-sm text-tertiary">{props.description}</div>
              </div>
              <div className="flex gap-lg pt-4xl">
                <Button
                  className="flex-1"
                  color="secondary"
                  size="lg"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button
                  className="flex-1"
                  color="primary-destructive"
                  size="lg"
                  onClick={handleConfirm}
                  data-ph-capture-attribute-action={
                    props["data-ph-capture-attribute-action"]
                  }
                >
                  Yes, remove
                </Button>
              </div>
            </div>
          </Dialog>
        </Modal>
      </ModalOverlay>
    </DialogTrigger>
  );
};
